import Vue from 'vue'
import Vuex from 'vuex'

import { IAppState } from '@app/componentlib/src/store/modules/app';
import { IProfileState } from './modules/profile'
import { ICVState } from '@app/componentlib/src/common/types/CVTypes'

Vue.use(Vuex)

export interface IRootState {
  app: IAppState,
  profile: IProfileState,
  cvdata: ICVState
}
//declare empty store - register the modules dynamically later
export default new Vuex.Store<IRootState>({})
